<template>
    <div class="empty">
        <img v-if="image" :src="image" :alt="title"/>
        <div class="title">{{title}}</div>
        <div class="text">{{text}}</div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component ({
        props: {
            title: String,
            text: String,
            image: String
        }
    })
    export default class EmptyView extends Vue {
        name = 'empty-view';
    }

    Vue.component('empty-view', EmptyView);
</script>

<style src="./styles.scss" lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/empty/EmptyView.vue